module.exports = __webpack_public_path__ + "images/euromobilf18ec670d1e763fc733f89e08a6ff57a.png";